import CrudRepository from './CrudRepository'
export default class PressReleaseNewsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/news/web/top')
  }
}
